import { render, staticRenderFns } from "./webSupport.vue?vue&type=template&id=da633dea&scoped=true"
import script from "./webSupport.vue?vue&type=script&lang=js"
export * from "./webSupport.vue?vue&type=script&lang=js"
import style0 from "./webSupport.vue?vue&type=style&index=0&id=da633dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da633dea",
  null
  
)

export default component.exports